import React from 'react';

import './ImageList.scss';
import Icon from 'Core/Components/Icon';
import ImageBox from 'RLX/Forms/ImageBox';
import ListField from 'RLX/Forms/ListField';
import OrderingControls from 'Core/Components/OrderingControls';

class ImageList extends ListField {
  constructor (props) {
    super(props);
    this.renderListItem = this.renderListItem.bind(this);
    this.getItemDefaults = this.getItemDefaults.bind(this);
  }

  getItemDefaults () {
    return '';
  }

  getClassName () {
    return 'ImageList';
  }

  shouldPromptBeforeDeleting (imageUrl) {
    return imageUrl && imageUrl.length;
  }

  renderListItem (imageUrl, index, imageCount) {
    const { onItemUpdate, onItemDelete, onItemReorder } = this;
    const changeHandler = (newValue) => onItemUpdate(newValue, index);
    const deleteHandler = () => onItemDelete(index);
    const reorderHandler = (direction, disabled) => {
      if (disabled) return;
      return onItemReorder(index, direction);
    };
    return (
      <div className="ImageList-Item" key={index}>
        <ImageBox
          label="Image URL"
          onChange={changeHandler}
          value={imageUrl}
        />
        <div className="ImageList-Item-Buttons">
          <div className="ImageList-Item-Directions">
            <OrderingControls
              isFirst={!index}
              isLast={imageCount === index + 1}
              horizontal={true}
              handleMove={reorderHandler}
              controlWrapper={(content) => (
                <button className="slim positive">{content}</button>
              )}
            />
          </div>
          <div className="ImageList-Item-Actions">
            <button className="slim negative" onClick={deleteHandler}>
              Remove <Icon fa="trash right"/>
            </button>
          </div>
        </div>
      </div>
    )
  }
};

export default ImageList;



// WEBPACK FOOTER //
// ./client/RLX/Forms/ImageList/ImageList.jsx